export default __webpack_public_path__ + "static/media/logo-brand.20000aff.svg";